import React, { useState } from "react";
import { Edit } from "@mui/icons-material";
import { Box, MenuItem, Typography } from "@mui/material";
import { StyledIconBox, StyledLeagueSelector } from "./styles";
import { useSelector } from "react-redux";

const DMPTitleBar = ({
  name,
  handleToggle,
  show,
  leagueId,
  handleLeagueId,
}) => {
  const getDmpList = useSelector((state) => state.getDmpList);
  const { role } = useSelector((state) => state.userDetailsReducer);

  return (
    <Box
      sx={{ display: "flex", justifyContent: "space-between" }}
      flexDirection={{ xs: "column", md: "row" }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          fontSize: { md: "20px", xxl: "40px" },
        }}
        color="initial"
      >
        {name}
      </Typography>
      <Box sx={{ display: "flex", marginRight: "0 !important" }}>
        {show && (
          <StyledLeagueSelector
            fullWidth
            value={leagueId}
            disableUnderline
            variant="standard"
            onChange={(e) => handleLeagueId(e.target.value)}
          >
            {getDmpList?.data?.leagues.map((league, index) => (
              <MenuItem value={league._id} key={index}>
                {league.name}
              </MenuItem>
            ))}
          </StyledLeagueSelector>
        )}

        {(role === "admin" || role === "super") && (
          <StyledIconBox onClick={handleToggle}>
            <Edit sx={{ color: "white" }} />
          </StyledIconBox>
        )}
      </Box>
    </Box>
  );
};
export default DMPTitleBar;
